import { useContext } from 'react';
import { QueryQueueContext } from './QueryQueueContext';

export const useQueryQueueContext = () => {
  const context = useContext(QueryQueueContext);
  if (!context) {
    throw new Error('useQueryQueueContext must be used within an QueryQueueProvider');
  }
  return context;
};
